module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/flame_bg-eba02fd9a3c897a67ec00f47f444e6d9.svg";